/**
 * Public paths measured by cookieless site analytics.
 *
 * Client-safe: the page-view tracker imports this so it does not beacon app
 * routes. The collector applies the same rules again and is authoritative.
 */

/** Public pages we measure. Exact match, so id-bearing app paths never qualify. */
export const TRACKED_SITE_PATHS = [
  '/',
  '/landing',
  '/sign-in',
  '/sign-up',
  '/invite',
  '/accept-invite',
  '/forgot-password',
  '/privacy',
  '/terms',
  '/cookies',
] as const

const TRACKED_PATH_SET = new Set<string>(TRACKED_SITE_PATHS)

/**
 * Returns the canonical tracked path, or null when the path must not be stored.
 * Invitation links (`/invite/<token>` and `/invite/platform/<token>`) collapse
 * to `/invite` so the secret is never written.
 */
export function normaliseTrackedPath(raw: string): string | null {
  const withoutSuffix = raw.split(/[?#]/, 1)[0] ?? ''
  const trimmed =
    withoutSuffix.length > 1 ? withoutSuffix.replace(/\/+$/, '') : withoutSuffix
  const path = trimmed.toLowerCase()
  if (TRACKED_PATH_SET.has(path)) return path
  if (path.startsWith('/invite/')) return '/invite'
  return null
}
